var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { RouteFiller } from "../helpers/Helpers";
import { CollaborationServiceSetup } from "../Setup";
var PostControllerExcite = /** @class */ (function () {
    function PostControllerExcite() {
    }
    /*****************************************************************************************************
        * Is using route "api/post/porschemoment" and http method "POST" to call the back-end.
    
        * @param {PorscheMomentPostUploadDto} data
        * @param {File} file
        * @param {File} file1
        * @param {File} file2
        * @param {File} file3
        * @param {File} file4
        * @returns {PorscheMomentPostDownloadDto}
    ******************************************************************************************************/
    PostControllerExcite.PostBinaryAsync = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("data", JSON.stringify(data.data));
        if (data.file)
            fd.append("file", data.file);
        if (data.file1)
            fd.append("file1", data.file1);
        if (data.file2)
            fd.append("file2", data.file2);
        if (data.file3)
            fd.append("file3", data.file3);
        if (data.file4)
            fd.append("file4", data.file4);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/porschemoment", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/post/PorscheMomentPost/{id}" and http method "PATCH" to call the back-end.
    
        * @param {string} id
        * @param {File} file
        * @param {File} file1
        * @param {File} file2
        * @param {File} file3
        * @param {File} file4
        * @param {PorscheMomentPostUploadDto} data
        * @returns {PorscheMomentPostDownloadDto}
    ******************************************************************************************************/
    PostControllerExcite.PatchPorscheMomentPostBinaryAsync = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.file)
            fd.append("file", data.file);
        if (data.file1)
            fd.append("file1", data.file1);
        if (data.file2)
            fd.append("file2", data.file2);
        if (data.file3)
            fd.append("file3", data.file3);
        if (data.file4)
            fd.append("file4", data.file4);
        fd.append("data", JSON.stringify(data.data));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/PorscheMomentPost/{id}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/post/porscheMoments/statistics" and http method "POST" to call the back-end.
    
        * @param {PorscheMomentStatsFilterDto} filter
        * @returns {PorscheMomentsStatDto[]}
    ******************************************************************************************************/
    PostControllerExcite.GetPorscheMomentsStatistics = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/porscheMoments/statistics", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.filter
        });
    };
    /*****************************************************************************************************
        * Is using route "api/post/porscheMoments/engagement" and http method "POST" to call the back-end.
    
        * @param {PorscheMomentStatsFilterDto} filter
        * @returns {PorscheMomentsStatDto[]}
    ******************************************************************************************************/
    PostControllerExcite.GetEngagementRate = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/porscheMoments/engagement", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.filter
        });
    };
    /*****************************************************************************************************
        * Is using route "api/post/porscheMoments/groupStats" and http method "POST" to call the back-end.
    
        * @param {PorscheMomentStatsFilterDto} filter
        * @returns {GroupStatDto[]}
    ******************************************************************************************************/
    PostControllerExcite.GetGroupStatistics = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/porscheMoments/groupStats", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.filter
        });
    };
    /*****************************************************************************************************
        * Is using route "api/post/porscheMoments/groupStats/shot" and http method "POST" to call the back-end.
    
        * @param {PorscheMomentStatsFilterDto} filter
        * @returns {GroupStatDto[]}
    ******************************************************************************************************/
    PostControllerExcite.GetGroupStatisticsShot = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/porscheMoments/groupStats/shot", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.filter
        });
    };
    /*****************************************************************************************************
        * Is using route "api/post/porscheMoments/topReactions" and http method "POST" to call the back-end.
    
        * @param {PorscheMomentStatsFilterDto} filter
        * @returns {PorscheMomentWithReactionsDto[]}
    ******************************************************************************************************/
    PostControllerExcite.GetPorscheMomentsWithTopReactions = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/porscheMoments/topReactions", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.filter
        });
    };
    /*****************************************************************************************************
        * Is using route "api/post/porscheMoments/mostActiveUsers" and http method "POST" to call the back-end.
    
        * @param {PorscheMomentStatsFilterDto} filter
        * @returns {UserWithReactionsDto[]}
    ******************************************************************************************************/
    PostControllerExcite.GetMostActiveUsers = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/porscheMoments/mostActiveUsers", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.filter
        });
    };
    return PostControllerExcite;
}());
export { PostControllerExcite };
/*
$PrintDebugInfo
*/ 
//# sourceMappingURL=PostControllerExcite.js.map